/* eslint-disable @typescript-eslint/no-unused-vars */

import styled from 'styled-components';
import GlobalStyle from './GlobalStyle';

type Props = {
  inputLabel?: string;
  inputPlaceholder: string;
  inputType: string;
  inputName: string;
  inputValue: string;
  onInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onInputBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onInputFocus?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onInputTogglePassword?: () => void;
  onInputKeyDown?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  optional?: string;
  error?: string;
  isPassword?: boolean;
  inputClassName?: string;
  autocomplete?: string;
  inputStyle?: object;
  isDisabled?: boolean;
} & typeof defaultProps;

const defaultProps = {
  optional: '',
  inputLabel: '',
  error: '',
  isPassword: false,
  inputClassName: '',
  autocomplete: 'new-password',
  inputStyle: {},
  onInputChange(e: React.ChangeEvent<HTMLInputElement>) { },
  onInputBlur(e: React.ChangeEvent<HTMLInputElement>) { },
  onInputFocus(e: React.ChangeEvent<HTMLInputElement>) { },
  onInputTogglePassword() { },
  onInputKeyDown(e: React.ChangeEvent<HTMLInputElement>) { },
  isDisabled: false,
};

const InputWrapper = styled.div`
  position: relative;
  .error-msg {
    color: #ffa112;
    font-style: italic;
    font-size: 14px;
    text-align: right;
    float: right;
    margin-top: 1px;
    margin-right: 5px;
    font-family: "Roboto_italic";
    font-weight: normal;
  }
`;

const Input = function Input(props: Props) {
  const {
    inputType,
    inputLabel,
    optional,
    error,
    isPassword,
    onInputChange,
    onInputBlur,
    onInputFocus,
    inputClassName,
    inputName,
    inputValue,
    inputPlaceholder,
    onInputTogglePassword,
    inputStyle,
    isDisabled,
  } = props;
  return (
    <>
      <GlobalStyle />
      <label className="auth-input-label" htmlFor="auth-input">
        {inputLabel}
        {optional && <span className="optional">(optional)</span>}
        {error && !isPassword ? (
          <span className="error-msg">
            {error || '* This field is mandatory '}
          </span>
        ) : null}
        {error && isPassword ? (
          <span className="error-msg">
            {error || '* This field is mandatory '}
          </span>
        ) : null}
      </label>
      <InputWrapper>
        <input
          disabled={isDisabled}
          {...props}
          onChange={(e) => onInputChange(e)}
          id="auth-input"
          className={`auth-input ${inputClassName} ${error ? 'error' : ''} ${isPassword ? 'password' : ''}`}
          name={inputName}
          value={inputValue}
          type={inputType}
          placeholder={inputPlaceholder}
          spellCheck={false}
          onBlur={onInputBlur}
          onFocus={onInputFocus}
          style={{ ...inputStyle }}
        />
        <span
          onClick={onInputTogglePassword}
          className={`input-span-hide ${inputType === 'password' ? '' : 'active'}`}
          onKeyPress={onInputTogglePassword}
          role="button"
          aria-label={inputName}
          tabIndex={0}
        >
          <span>{inputName}</span>
        </span>
      </InputWrapper>
    </>
  );
};

Input.defaultProps = defaultProps;

export default Input;
